import IconButton from "@/components/IconButton";
import type { ReactNode } from "react";

type BeneficiaryFormCardProps = {
  heading: string;
  headerEnd?: ReactNode;
  onRemove?: () => void;
  removeAriaLabel?: string;
  children: ReactNode;
  "data-testid"?: string;
};

export default function BeneficiaryFormCard({
  heading,
  headerEnd,
  onRemove,
  removeAriaLabel = "Remove beneficiary",
  children,
  "data-testid": dataTestId
}: BeneficiaryFormCardProps) {
  return (
    <div
      className="flex flex-col items-start rounded-[16px] border border-sys-brand-outline-variant bg-sys-brand-surface-container"
      data-testid={dataTestId}
    >
      <div className="flex w-full flex-col px-5 pt-4">
        <div className="grid w-full grid-cols-[1fr_auto] gap-x-4 gap-y-4 lg:grid-cols-[1fr_auto_auto] lg:items-center">
          <h4 className="col-start-1 row-start-1 self-center text-title-medium-bold font-serif">{heading}</h4>
          {onRemove ? (
            <div className="col-start-2 row-start-1 flex items-center justify-self-end self-center lg:col-start-3">
              <IconButton
                name="delete"
                ariaLabel={removeAriaLabel}
                skipMargin
                onClick={(event) => {
                  event.preventDefault();
                  onRemove();
                }}
                data-testid={`${dataTestId}-remove`}
              />
            </div>
          ) : null}
          {headerEnd ? (
            <div className="col-span-2 row-start-2 w-full self-center lg:col-span-1 lg:col-start-2 lg:row-start-1 lg:w-auto">
              {headerEnd}
            </div>
          ) : null}
        </div>
        <hr className="mt-4 h-px w-full border-t border-sys-brand-outline-variant" />
      </div>
      <div className="grid w-full gap-6 px-5 pb-8 pt-7 md:grid-cols-2">{children}</div>
    </div>
  );
}
